<div class="cart-header">
    <div class="cart-header__inner">

        <div class="cart-header__hd">
            <shared-header *ngIf="pickupTimeLabel" [inverted]="headerSubInverted" [brandAccent]="true" type="5"
                marginTop="none" marginBottom="xs">
                {{pickupTimeLabel | uppercase}}
            </shared-header>
            <shared-header class="cart-header__title" type="3" [inverted]="headerMainInverted" marginTop="none"
                marginBottom="md">
                {{totalPrefix}}{{total | currency : config.localization.currency:'symbol-narrow':null: config.localization.locale}}</shared-header>
        </div>


        <div class="cart-header__actions">

            <div class="cart-header__col -left -for-order-more">
                <shared-btn class="cart-header__btn -for-order-more" [width]="btnWidth" [size]="btnSize"
                    [feel]="btnFeelOrderMore" [inverted]="btnInvertedOrderMore"
                    (onClick)="handleOrderMoreClick($event)">
                    {{labelOrderMore}}</shared-btn>
            </div>

            <div class="cart-header__col -right -for-checkout">
                <shared-btn [width]="btnWidth" [size]="btnSize" [feel]="btnFeelCheckout"
                    class="cart-header__btn -for-checkout" [inverted]="btnInvertedCheckout" [loading]="loadingAfterCheckout"
                    (onClick)="handleCheckoutClick($event)">{{labelCheckout}}
                </shared-btn>
            </div>

        </div>

    </div>
</div>
